import { all_roles } from '@/utils';
import { GlobalSearch } from '@/modules/global-search/types';

const access_roles = {
  [GlobalSearch.Pages.SEARCH]: all_roles,
};

export default access_roles;
